var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2E2E2E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.67,
  d: "m9.667 12.668 1.555 1.556 3.111-3.111m4.37-3.124q-.24.013-.48.013A9.3 9.3 0 0 1 12 5.625a9.3 9.3 0 0 1-6.703 2.364A9.4 9.4 0 0 0 5 10.335c0 4.349 2.974 8.003 7 9.04 4.026-1.037 7-4.691 7-9.04 0-.81-.103-1.596-.297-2.346"
})));
export default SvgBadge;